<template>
	<div class="msg-center-container">
		<div class="content-container">
			<BreadCrumb :routerLinks="routerLinks" currentTitle="立即购买"></BreadCrumb>
			<div class="orderBox">
				<div class="orderInfoBox">
					<div class="title">
						确认订单信息
					</div>
					<div class="subTitle">
						作品信息
					</div>
					<div class="bannerWorkTitleTips">
						<img class="banner" :src="orderInfo.img" />
						<div class="WorkTitleTips">
							<div class="workTitle">{{orderInfo.title ? orderInfo.title : ''}}</div>
							<div class="tips" v-if="orderInfo.label">
								<div class="tip" v-for="(item,index) in orderInfo.label" :key="index">{{item}}</div>
							</div>
						</div>
					</div>
					<div class="subTitle">
						版权说明
					</div>
					<div class="desc">
						{{orderInfo.banquan ? orderInfo.banquan : ''}}
					</div>
					<div class="subTitle">
						选择下单作品
					</div>
					<div class="workList">
						<div class="work" v-for="(item,index) in imgList" :key="index" @click="changeImg(item)">
							<img class="workBanner" :src="item.img" />
							<img class="ckeckIcon" src="../assets/BuyNow/iconC.png"
								v-if="selImgList.findIndex(row =>row == item.id) > -1" />
							<img class="ckeckIcon" src="../assets/BuyNow/iconG.png" v-else />
							<img class="soldOutIcon" src="../assets/BuyNow/iconJ.png" v-if="item.status == 1" />
							<div class="indexNo">NO.{{index + 1}}</div>
						</div>
					</div>
					<div class="subTitle">
						选择下单用途
					</div>
					<el-select v-model="purpose" class="inputBox" placeholder="请选择下单用途" clearable>
						<el-option v-for="item in purposeOpts" :key="item.id" :label="item.yongtu" :value="item.id" />
					</el-select>
				</div>
				<div class="payInfoBox">
					<div class="title">
						订单信息
					</div>
					<div class="orderPriceBox">
						<div class="itemTitle">订单金额</div>
						<div class="priceBox" style="margin-right: .1rem;">
							<div class="price">
								<span class="unit">¥</span>
								{{orderCost}}
							</div>
						</div>
					</div>
					<div class="orderPriceBox" style="cursor: pointer;" @click="handleCoupon">
						<div class="itemTitle">代金券</div>
						<div class="priceBox">
							<div class="price">
								<span class="unit">¥</span>
								{{couponCost}}
							</div>
							<img class="arrow" src="../assets/BuyNow/iconI.png" />
						</div>
					</div>
					<div class="payWayBox">
						<div class="payItem" @click="payWay = 1">
							<img class="checkIcon" src="../assets/BuyNow/iconC.png" v-if="payWay == 1" />
							<img class="checkIcon" src="../assets/BuyNow/iconF.png" v-else />
							<img class="payIcon" src="../assets/BuyNow/iconE.png" />
							微信支付
						</div>
						<div class="payItem" @click="payWay = 2">
							<img class="checkIcon" src="../assets/BuyNow/iconC.png" v-if="payWay == 2" />
							<img class="checkIcon" src="../assets/BuyNow/iconF.png" v-else />
							<img class="payIcon" src="../assets/BuyNow/iconD.png" />
							支付宝支付
						</div>
					</div>
					<div class="agreementBox">
						<img class="checkIcon" src="../assets/BuyNow/iconA.png" @click="agree = false" v-if="agree" />
						<img class="checkIcon" src="../assets/BuyNow/iconH.png" @click="agree = true" v-else />
						我已阅读并同意 <span class="userAgreement" @click.stop="naviToAgree">《用户购买须知协议》</span>
					</div>
					<div class="costButNow">
						<div class="costBox">
							实付款
							<div class="cost">
								<span class="unit">¥</span>
								{{cost}}
							</div>
						</div>
						<div class="buyNow" @click="marketOrderAdd">立即购买</div>
					</div>
				</div>
			</div>
		</div>
		<CouponDialog :show="dialogCouponVisible" @close="handleClose" @update="curCoupon = $event"
			methodName="/Order/order_coupon"
			:params="{goods_id: $route.query.id,yongtu: purpose,img_id: selImgList.join(',')}" />
		<el-dialog class="reportDialog" :visible.sync="dialogReportVisible" append-to-body @close="handleClose">
			<div slot="title">
				<div class="dislogTitle">
					支付二维码
				</div>
			</div>
			<div class="dislogConent">
				<img :src="payUrl" style="width: 2rem;height: 2rem;" />
			</div>
			<div slot="footer">
				<div class="menuBox">
					<el-button plain size="medium" @click="dialogReportVisible = false">取消</el-button>
				</div>
			</div>
		</el-dialog>
		<UserBuyAgreeDialog :show="userBuy" @close="userBuy = false" />
		<PopToast :imgPtahUrl="require('@/assets/Feedback/sucIcon.png')" :desc="'购买成功！'" :subTitle="'请到个人中心我的订单中查看！'"
			@clickOk="sucPop = false;$router.replace({path:'/personal-center',query: {menuId: 12}})" v-if="sucPop" />
	</div>
</template>
<script>
	import QRCode from 'qrcode';
	import PopToast from '../components/PopToast.vue'
	import UserBuyAgreeDialog from '../components/UserBuyAgreeDialog.vue'
	import CouponDialog from '../../src/components/CouponDialog.vue'
	export default {
		name: 'BuyNow',
		components: {
			PopToast,
			CouponDialog,
			UserBuyAgreeDialog
		},
		data() {
			return {
				userBuy: false,
				sucPop: false,
				timer: null,
				payUrl: '',
				dialogReportVisible: false,
				orderId: '',
				curCoupon: {},
				agree: true,
				payWay: 1,
				purpose: '',
				orderInfo: {},
				imgList: [],
				selImgList: [],
				activeName: '0',
				dialogCouponVisible: false,
				purposeOpts: [],
				routerLinks: [{
					path: '/personal-center',
					title: '图片订单',
					query: {
						menuId: 12
					}
				}]
			}
		},
		computed: {
			//优惠券金额
			couponCost() {
				let total = 0
				if (this.purposeOpts.length > 0 && this.purpose) {
					const item = this.purposeOpts.find(row => row.id == this.purpose)
					if (item && item.price) {
						if (this.selImgList.length > 0) {
							if (this.curCoupon.id) {
								if (this.curCoupon.v_type == 1) {
									total = this.curCoupon.original_price * 1
								} else {
									total = (1 - this.curCoupon.original_price / 10) * item.price * this.selImgList
										.length * 1
								}
							} else {
								total = 0
							}
						} else {
							total = 0
						}
					} else {
						total = 0
					}
				}
				return total.toFixed(2)
			},
			//订单金额
			orderCost() {
				let total = 0
				if (this.purposeOpts.length > 0 && this.purpose) {
					const item = this.purposeOpts.find(row => row.id == this.purpose)
					if (item && item.price) {
						if (this.selImgList.length > 0) {
							total = item.price * this.selImgList.length
						} else {
							total = 0
						}
					} else {
						total = 0
					}
				}
				return total.toFixed(2)
			},
			//实付金额
			cost() {
				let total = 0
				if (this.purposeOpts.length > 0 && this.purpose) {
					const item = this.purposeOpts.find(row => row.id == this.purpose)
					if (item && item.price) {
						if (this.selImgList.length > 0) {
							if (this.curCoupon.id) {
								if (this.curCoupon.v_type == 1) {
									total = item.price * this.selImgList.length - this.curCoupon.original_price * 1 >= 0 ?
										item.price * this.selImgList.length - this.curCoupon.original_price * 1 : 0
								} else {
									total = item.price * this.selImgList.length - (1 - this.curCoupon.original_price /
											10) *
										item
										.price * this.selImgList.length * 1
								}
							} else {
								total = item.price * this.selImgList.length
							}
						} else {
							total = 0
						}
					} else {
						total = 0
					}
				}
				return total.toFixed(2)
			},
		},
		mounted() {
			this.huaOrder()
		},
		beforeDestroy() {
			if (this.timer) {
				clearInterval(this.timer);
			}
		},
		methods: {
			changeImg(item) {
				if (item.status == 1) return
				const index = this.selImgList.findIndex(row => row == item.id)
				if (index > -1) {
					this.selImgList.splice(index, 1)
				} else {
					this.selImgList.push(item.id)
				}
				this.curCoupon = {}
			},
			naviToAgree() {
				this.userBuy = true
			},
			//获取下单信息
			huaOrder() {
				this.$api.post('/Hua/hua_order', {
					id: this.$route.query.id,
				}).then(res => {
					if (res.code == 1) {
						this.orderInfo = res.data
						this.imgList = res.data.banner
						this.purposeOpts = res.data.yongtu
						this.purpose = this.$route.query.purpose * 1
					}
				}).catch(err => {
					console.log(err);
				})
			},
			//点击获取优惠券
			handleCoupon() {
				if (this.selImgList.length == 0) return this.$message.warning('请先选择下单作品')
				if (!this.purpose) return this.$message.warning('请先选择下单用途')
				this.dialogCouponVisible = true
			},
			//立即购买
			marketOrderAdd() {
				if (this.selImgList.length == 0) return this.$message.warning('请先选择下单作品')
				if (!this.purpose) return this.$message.warning('请先选择下单用途')
				if (!this.agree) return this.$message.warning('请阅读并同意《用户购买须知协议》')
				this.$api.post('/Hua/hua_order_add', {
					id: this.$route.query.id,
					img_id: this.selImgList.join(','),
					coupon_id: this.curCoupon.id,
					yongtu: this.purpose
				}).then(res => {
					if (res.code == 1) {
						this.submitOrder(res.data.order_id)
					}
				}).catch(err => {
					console.log(err);
				})
			},
			//通联支付
			submitOrder(orderId) {
				this.$api.post('/Tonglian/nativepay', {
					id: orderId,
				}).then(res => {
					if (res.code == 1) {
						this.orderId = orderId
						this.generateQRCode(res.data)
					}
				}).catch(err => {
					console.log(err);
				})
			},
			//转换支付二维码
			generateQRCode(text) {
				let that = this
				QRCode.toDataURL(text, function(error, url) {
					that.payUrl = url
					that.dialogReportVisible = true
					that.timer = setInterval(() => {
						that.checkOrder()
					}, 5000)
				});
			},
			//校验订单
			checkOrder() {
				this.$api.post('/Notify/check_order', {
					order_id: this.orderId,
					type: 1
				}).then(res => {
					if (res.code == 1) {
						this.dialogReportVisible = false
						this.sucPop = true
						clearInterval(this.timer);
						this.timer = null
						//去订单列表
					}
				}).catch(err => {
					console.log(err);
				})
			},
			handleClose() {
				this.dialogCouponVisible = false
				this.dialogReportVisible = false
				clearInterval(this.timer);
				this.timer = null
			},
		}
	}
</script>

<style lang="scss" scoped>
	.msg-center-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		background: #FDFDF4;
		min-height: 100vh;
	}

	.content-container {
		margin-bottom: .32rem;
		width: 12rem;
		display: flex;
		flex-direction: column;
	}

	.orderBox {
		margin-top: .2rem;
		width: 12rem;
		display: flex;
		justify-content: space-between;

		.orderInfoBox {
			display: flex;
			flex-direction: column;
			width: 8.95rem;
			background: #FFFFFF;
			box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
			border-radius: .12rem;
			padding: .24rem .24rem;

			.title {
				font-weight: 500;
				font-size: .16rem;
				color: #1C1C1C;
				line-height: .24rem;
			}

			.subTitle {
				margin-top: .24rem;
				font-weight: 400;
				font-size: .12rem;
				color: #666666;
				line-height: .18rem;
			}

			.bannerWorkTitleTips {
				margin-top: .12rem;
				display: flex;
				align-items: flex-start;

				.banner {
					width: .58rem;
					height: .78rem;
					overflow: hidden;
					border-radius: .08rem;
					object-fit: cover;
				}

				.WorkTitleTips {
					margin-left: .12rem;
					display: flex;
					flex-direction: column;

					.workTitle {
						font-weight: 700;
						font-size: .16rem;
						color: #000000;
						line-height: .22rem
					}

					.tips {
						margin-top: .12rem;
						display: flex;
						align-items: center;

						.tip {
							margin-right: .12rem;
							height: .26rem;
							padding: 0 .08rem;
							border-radius: .13rem;
							border: .01rem solid #A88653;
							font-weight: 400;
							font-size: .12rem;
							color: #7C3E0B;
							line-height: .26rem;
						}
					}
				}
			}

			.desc {
				margin-top: .04rem;
				font-weight: 400;
				font-size: .12rem;
				color: #000000;
				line-height: .22rem;
			}

			.workList {
				display: flex;
				flex-wrap: wrap;

				.work:nth-child(7n) {
					margin-right: 0;
				}

				.work {
					display: flex;
					position: relative;
					margin-right: .1rem;
					margin-top: .16rem;
					width: 1.12rem;
					height: 1.5rem;
					overflow: hidden;
					border-radius: .08rem;
					object-fit: cover;
					cursor: pointer;

					.workBanner {
						width: 1.12rem;
						height: 1.5rem;
					}

					.ckeckIcon {
						position: absolute;
						width: .14rem;
						height: .14rem;
						top: .08rem;
						right: .05rem;
					}

					.soldOutIcon {
						position: absolute;
						width: 1.12rem;
						height: 1.5rem;
						top: 0;
						left: 0;
					}

					.indexNo {
						position: absolute;
						left: .14rem;
						bottom: .1rem;
						height: .2rem;
						padding: 0 .06rem;
						border-radius: .1rem;
						background: rgba(0, 0, 0, .5);
						font-weight: 400;
						font-size: .12rem;
						color: #FFFFFF;
						line-height: .2rem;
					}
				}
			}

			.inputBox {
				margin-top: .12rem;
				width: 2.5rem;
			}

			::v-deep .el-input {

				&__inner {
					width: 2.5rem;
					height: .4rem;
					font-weight: 400;
					font-size: .14rem;
					color: #252525;
					line-height: .4rem;
					border: .01rem solid #EFD8B8;
				}

				&__icon {
					font-size: .14rem;
					line-height: .4rem;
				}
			}
		}
	}

	.payInfoBox {
		display: flex;
		flex-direction: column;
		width: 2.88rem;
		background: #FFFFFF;
		padding: .24rem .24rem;
		box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
		border-radius: .12rem;

		.title {
			margin-bottom: .06rem;
			font-weight: 600;
			font-size: .16rem;
			color: #333333;
			line-height: .22rem;
		}

		.orderPriceBox {
			margin-top: .1rem;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.itemTitle {
				font-weight: 400;
				font-size: .14rem;
				color: #333333;
			}

			.priceBox {
				display: flex;
				align-items: center;

				.price {
					display: flex;
					align-items: baseline;
					font-weight: 700;
					font-size: .2rem;
					color: #FF0100;

					.unit {
						font-weight: 400;
						font-size: .14rem;
					}
				}


				.arrow {
					margin-left: .04rem;
					width: .06rem;
					height: .1rem;
				}
			}
		}

		.payWayBox {
			margin-top: .24rem;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			width: 2.4rem;
			height: .96rem;
			background: #FFFFFF;
			border-radius: .08rem;
			border: .01rem solid #EFD8B8;
			padding: .2rem .16rem;

			.payItem {
				display: flex;
				align-items: center;
				font-weight: 500;
				font-size: .14rem;
				color: #333333;
				line-height: .2rem;

				.checkIcon {
					margin-right: .16rem;
					width: .14rem;
					height: .14rem;
				}

				.payIcon {
					margin-right: .06rem;
					width: .16rem;
					height: .16rem;
				}
			}
		}

		.agreementBox {
			margin-top: .12rem;
			display: flex;
			align-items: center;
			font-size: .12rem;

			.checkIcon {
				margin-right: .06rem;
				width: .14rem;
				height: .14rem;
				cursor: pointer;
			}

			.userAgreement {
				cursor: pointer;
				color: #E29358;
			}
		}

		.costButNow {
			margin-top: .4rem;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.costBox {
				display: flex;
				flex-direction: column;
				font-weight: 400;
				font-size: .12rem;
				color: #333333;

				.cost {
					display: flex;
					align-items: baseline;
					font-weight: 700;
					font-size: .24rem;
					color: #FF0000;

					.unit {
						font-weight: 400;
						font-size: .14rem;
					}
				}
			}

			.buyNow {
				width: 1rem;
				height: .48rem;
				background: #E29358;
				border-radius: .06rem;
				font-weight: 500;
				font-size: .16rem;
				color: #252525;
				line-height: .48rem;
				text-align: center;
				cursor: pointer;
			}
		}
	}

	.reportDialog {

		::v-deep .el-dialog {
			width: 3rem;
			border-radius: .12rem;

			&__header {
				padding: .24rem .24rem;

				.dislogTitle {
					font-weight: 500;
					font-size: .18rem;
					color: #252525;
				}
			}

			&__body {
				padding: 0 .24rem;
				display: flex;
				flex-direction: column;
				align-items: center;

				.el-form {

					&-item:nth-child(4),
					&-item:nth-child(5) {
						align-items: flex-start;

						.el-form-item__label {
							margin-top: .16rem;
						}
					}

					&-item {
						display: flex;
						align-items: center;
						margin-bottom: .24rem;

						&__label {
							width: 1.1rem;
							font-size: .14rem;
							color: #252525;
							line-height: .2rem;
						}

						&__error {
							font-size: .12rem;
							padding-top: .04rem;
						}

						&__content {

							.el-input {

								&__inner {
									width: 4.1rem;
									height: .52rem;
									font-weight: 400;
									font-size: .14rem;
									color: #252525;
									line-height: .52rem;
									border: .01rem solid #EFD8B8;
								}

								&__icon {
									font-size: .14rem;
								}
							}
						}
					}
				}
			}

			&__footer {
				padding: .08rem .24rem .24rem;

				.menuBox {
					display: flex;
					align-items: center;
					justify-content: center;

					.submit {
						margin: .32rem auto 0;
						width: 1.3rem;
						height: .36rem;
						background: #E29358;
						border-radius: .04rem;
						padding: 0 0;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
						text-align: center;
						line-height: .36rem;
						border: none;
						cursor: pointer;
					}
				}
			}
		}
	}

	li {
		width: 2.5rem;
		font-size: .14rem !important;
		margin-bottom: 0;
	}
</style>